import facetGetters from '~/modules/catalog/category/getters/facetGetters';
import { useProductSearch } from '~/modules/catalog/category/composables/useFacet/useProductSearch';
import { useWebsiteCode } from '~/composables/useWebsiteCode';
import { searchAutocompleteQuery } from '~/customQueries/search';

type CustomQuery = (params: {
  query: string;
  queryVariables?: Record<string, unknown>;
}) => Promise<any>;

type SearchBarResultsOptions = {
  customQuery: CustomQuery;
};

type AutoCompleteResponse = {
  AutoComplete?: {
    success?: boolean;
    categories?: any[];
    correction?: string;
    sts?: any[];
  };
};

export const useSearchBarResults = ({ customQuery }: SearchBarResultsOptions) => {
  const { isBy } = useWebsiteCode();
  const {
    search: productSearch,
    result: productResult,
    error: productSearchError,
  } = useProductSearch();

  const fetchSearchResults = async (searchTerm: string, pageSize: number) => {
    const modalPageSize = Math.min(pageSize, 4);

    await productSearch({
      term: searchTerm,
      itemsPerPage: modalPageSize,
      loadSortOptions: false,
    });

    if (productSearchError.value?.search) {
      throw productSearchError.value.search;
    }

    const products = facetGetters.getProducts(productResult.value) ?? [];
    let autocomplete: AutoCompleteResponse['AutoComplete'];
    if (!isBy.value) {
      const { data } = await customQuery({
        query: searchAutocompleteQuery,
        queryVariables: { search: searchTerm },
      });
      autocomplete = data?.AutoComplete;
      if (autocomplete?.success === false) {
        throw new Error('Search autocomplete is temporarily unavailable');
      }
    }
    return {
      categories: isBy.value ? productResult.value.data?.categories ?? [] : autocomplete?.categories ?? [],
      // SearchProducts does not yet have a confirmed correction field.
      correction: isBy.value ? '' : autocomplete?.correction ?? '',
      products,
      redirectUrl: productResult.value.data?.redirectUrl ?? '',
      sts: isBy.value ? productResult.value.data?.sts ?? [] : autocomplete?.sts ?? [],
      total: productResult.value.data?.total ?? 0,
    };
  };

  return {
    fetchSearchResults,
  };
};
